// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBriefcase, FaVenusMars, FaClipboardList, FaTags, FaTrash, FaEdit, FaDatabase, FaSearch, FaCalendarAlt, FaIdBadge } from 'react-icons/fa';

// const CustomerManagement = () => {
//   const [search, setSearch] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const customersPerPage = 10;

//   const [customers, setCustomers] = useState([]);
//   const [editingCustomer, setEditingCustomer] = useState(null);

//   useEffect(() => {
//     fetchLeads();
//   }, []);

//   const fetchLeads = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       if (!user?.id) {
//         console.warn("User ID not found in sessionStorage");
//         return;
//       }
//       const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
//         params: { user_id: user.id }
//       });
//       // Filter only INTERESTED leads
//       const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
//       setCustomers(interestedLeads);
//     } catch (err) {
//       console.error('Error fetching leads:', err);
//     }
//   };


//   const handleEdit = (customer) => setEditingCustomer({ ...customer });

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this customer?')) return;
//     try {
//       await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/delete/${id}`);
//       const updated = customers.filter(c => c.id !== id);
//       setCustomers(updated);
//       // Adjust page if last item was deleted on last page
//       if ((currentPage - 1) * customersPerPage >= updated.length && currentPage > 1) {
//         setCurrentPage(currentPage - 1);
//       }
//     } catch (error) {
//       console.error('Failed to delete customer:', error);
//       alert('Error deleting customer. Please try again.');
//     }
//   };


//   const handleUpdate = async () => {
//     try {
//       const { id, ...updatedData } = editingCustomer;
//       await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/update/${id}`, updatedData);
//       setCustomers(prev =>
//         prev.map(cust => (cust.id === id ? editingCustomer : cust))
//       );
//       setEditingCustomer(null);
//     } catch (error) {
//       console.error('Failed to update customer:', error);
//       alert('Failed to update customer. Please try again.');
//     }
//   };

//   const handleSearch = (e) => {
//     setSearch(e.target.value);
//     setCurrentPage(1);
//   };

//   const filtered = customers.filter((c) =>
//     c.name?.toLowerCase().includes(search.toLowerCase()) ||
//     c.email?.toLowerCase().includes(search.toLowerCase()) ||
//     c.customer?.toLowerCase().includes(search.toLowerCase())
//   );

//   const indexOfLast = currentPage * customersPerPage;
//   const indexOfFirst = indexOfLast - customersPerPage;
//   const currentCustomers = filtered.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(filtered.length / customersPerPage);



//   const handleCallClick = (contact) => {
//     window.location.href = `tel:${contact}`;
//   };

//   const maskEmail = (email) => {
//     if (!email) return '';
//     const [user, domain] = email.split('@');
//     if (!domain) return email;
//     const visibleUser = user.slice(0, 2);
//     const maskedUser = '*'.repeat(user.length - 2);
//     return `${visibleUser}${maskedUser}@${domain}`;
//   };


//   return (
//     <div style={{ fontFamily: 'Arial', fontSize: '12px', }}>
//       <h3 style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FaDatabase /> CRM Dashboard</h3>

//       {/* Edit Form */}
//       {editingCustomer && (
//         <div style={{ background: '#fff', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom: '25px' }}>
//           <h4 style={formTitle}><FaClipboardList /> Edit Customer</h4>
//           <div style={formGrid}>
//             {renderInput('Name', 'name', editingCustomer.name, val => setEditingCustomer({ ...editingCustomer, name: val }), <FaUser />)}
//             {renderInput('Email', 'email', editingCustomer.email, val => setEditingCustomer({ ...editingCustomer, email: val }), <FaEnvelope />)}
//             {renderInput('Contact', 'contact', editingCustomer.contact, val => setEditingCustomer({ ...editingCustomer, contact: val }), <FaPhone />)}
//             {renderInput('Gender', 'gender', editingCustomer.gender, val => setEditingCustomer({ ...editingCustomer, gender: val }), <FaVenusMars />)}
//             {renderInput('Requirement', 'requirement', editingCustomer.requirement, val => setEditingCustomer({ ...editingCustomer, requirement: val }), <FaClipboardList />)}
//             {renderInput('Location', 'location', editingCustomer.location, val => setEditingCustomer({ ...editingCustomer, location: val }), <FaMapMarkerAlt />)}
//             {renderInput('Comment', 'Comment', editingCustomer.Comment, val => setEditingCustomer({ ...editingCustomer, Comment: val }), <FaBriefcase />)}
//             {renderInput('Gst', 'gst', editingCustomer.gst, val => setEditingCustomer({ ...editingCustomer, gst: val }), <FaIdBadge />)}
//           </div>
//           <div style={{ display: 'flex', gap: '10px' }}>
//             <button style={buttonStyle} onClick={handleUpdate}>Update</button>
//             <button style={{ ...buttonStyle, backgroundColor: '#ccc', color: '#333' }} onClick={() => setEditingCustomer(null)}>Cancel</button>
//           </div>
//         </div>
//       )}

//       {/* Search */}
//       <div style={{ margin: '15px 0', maxWidth: '300px', position: 'relative' }}>
//         <FaSearch style={{ position: 'absolute', top: '10px', left: '10px', color: '#888' }} />
//         <input type="text" value={search} onChange={handleSearch} placeholder="Search by name, customer, or email" style={{ padding: '8px 8px 8px 30px', width: '100%', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px' }} />
//       </div>

//       <div>
//         {/* Table for MD+ */}
//         <div style={{ overflowX: 'auto', display: window.innerWidth > 768 ? 'block' : 'none' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '800px' }}>
//             <thead>
//               <tr style={{ background: '#ffffffff' }}>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>#</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaUser />Name</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaEnvelope /> Email ID</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaPhone /> Mobile</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaVenusMars /> Gender</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaClipboardList /> Requirement</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaMapMarkerAlt /> Location</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaBriefcase /> Comment</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaCalendarAlt /> Created</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}><FaTags /> Gst</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Verified</th>
//                 <th style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentCustomers.length > 0 ? currentCustomers.map((cust, idx) => {
//                 const isVerified = (cust.gst || '').trim() !== '';
//                 return (
//                   <tr key={cust.id}>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{indexOfFirst + idx + 1}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{cust.name}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{maskEmail(cust.email)}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', }}><FaPhone onClick={() => handleCallClick(cust.contact)} style={{ color: '#007bff' }} title="Call Dealer" /></td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{cust.gender}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{cust.requirement}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{cust.location}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{cust.Comment}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{new Date(cust.createdDate).toLocaleDateString()}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{cust.gst}</td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                       {isVerified ? <span style={{ color: 'green' }}>✔</span> : <span style={{ color: 'red' }}>✖</span>}
//                     </td>
//                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                       <button style={iconButtonStyle} onClick={() => handleEdit(cust)}><FaEdit /></button>
//                       <button style={iconButtonStyle} onClick={() => handleDelete(cust.id)}><FaTrash /></button>
//                     </td>
//                   </tr>
//                 );
//               }) : (
//                 <tr>
//                   <td colSpan="13" style={{ textAlign: 'center', padding: '12px', color: '#777' }}>No customers found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         <div style={{ display: window.innerWidth <= 768 ? 'block' : 'none' }}>
//           {currentCustomers.length > 0 ? currentCustomers.map((cust, idx) => {
//             const isVerified = (cust.gst || '').trim() !== '';
//             return (
//               <div key={cust.id} style={{
//                 background: '#fff',
//                 padding: '12px',
//                 marginBottom: '12px',
//                 borderRadius: '8px',
//                 boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//                 fontSize: '14px'
//               }}>
//                 <div><strong>#{indexOfFirst + idx + 1}</strong></div>
//                 <div><strong>Name:</strong> {cust.name}</div>
//                 <div><strong>Email:</strong> {maskEmail(cust.email)}</div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                   <strong>Mobile:</strong> <FaPhone onClick={() => handleCallClick(cust.contact)} style={{ color: '#007bff', cursor: 'pointer' }} /> {cust.contact}
//                 </div>
//                 <div><strong>Gender:</strong> {cust.gender}</div>
//                 <div><strong>Requirement:</strong> {cust.requirement}</div>
//                 <div><strong>Location:</strong> {cust.location}</div>
//                 <div><strong>Comment:</strong> {cust.Comment}</div>
//                 <div><strong>Created:</strong> {new Date(cust.createdDate).toLocaleDateString()}</div>
//                 <div><strong>GST:</strong> {cust.gst}</div>
//                 <div><strong>Verified:</strong> {isVerified ? <span style={{ color: 'green' }}>✔</span> : <span style={{ color: 'red' }}>✖</span>}</div>
//                 <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
//                   <button style={{ ...iconButtonStyle, flex: 1 }} onClick={() => handleEdit(cust)}><FaEdit /> Edit</button>
//                   <button style={{ ...iconButtonStyle, flex: 1 }} onClick={() => handleDelete(cust.id)}><FaTrash /> Delete</button>
//                 </div>
//               </div>
//             );
//           }) : (
//             <div style={{ textAlign: 'center', padding: '12px', color: '#777' }}>No customers found.</div>
//           )}
//         </div>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div style={{ marginTop: '16px', textAlign: 'center' }}>
//           <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={paginationBtn(currentPage !== 1)}>Previous</button>
//           <span style={{ margin: '0 10px' }}>
//             Page {currentPage} of {totalPages}
//           </span>
//           <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} style={paginationBtn(currentPage !== totalPages)}>Next</button>
//         </div>
//       )}
//     </div>
//   );
// };

// // Input helper
// const renderInput = (label, name, value, onChange, icon) => (
//   <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', fontWeight: '600', gap: '4px', }}>
//     <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>{icon} {label}</span>
//     <input style={{ padding: '6px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '3px', }} value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={label} />
//   </label>
// );

// // Styles

// const formTitle = { display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px', };
// const formGrid = { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px', marginBottom: '10px', };
// const buttonStyle = { padding: '6px 12px', fontSize: '12px', cursor: 'pointer', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '3px', };
// const iconButtonStyle = { fontSize: '14px', marginRight: '5px', cursor: 'pointer', background: 'none', border: 'none', color: '#333', };


// const paginationBtn = (active) => ({
//   padding: '6px 10px',
//   margin: '0 5px',
//   borderRadius: '4px',
//   border: '1px solid #ccc',
//   cursor: active ? 'pointer' : 'not-allowed',
//   backgroundColor: active ? '#fff' : '#eee',
//   color: active ? '#007bff' : '#aaa',
//   fontSize: '13px'
// });

// export default CustomerManagement;



// import React, { useState, useEffect } from 'react';
// import { Plus, Search, Filter, Download, Mail, Edit, Eye, X, ChevronLeft, ChevronRight } from 'lucide-react';

// const ITEMS_PER_PAGE = 5;

// const initialCustomersData = [
//   {
//     id: 'C-001',
//     name: 'Acme Corporation',
//     contact: 'John Smith',
//     email: 'john@acme.com',
//     phone: '+1 234 567 8901',
//     totalOrders: 24,
//     totalSpent: '$48,500',
//     status: 'Active',
//     rating: 5,
//     joinDate: '2023-06-15',
//     gender: 'Male',
//     requirement: 'Product A',
//     location: 'Mumbai',
//     comment: 'Interested in product A',
//     gstUpdate: false
//   },
//   {
//     id: 'C-002',
//     name: 'TechStart Inc',
//     contact: 'Lisa Anderson',
//     email: 'lisa@techstart.com',
//     phone: '+1 234 567 8902',
//     totalOrders: 18,
//     totalSpent: '$32,200',
//     status: 'Active',
//     rating: 4,
//     joinDate: '2023-08-22',
//     gender: 'Female',
//     requirement: 'Product B',
//     location: 'Delhi',
//     comment: 'Follow up next week',
//     gstUpdate: true
//   },
//   {
//     id: 'C-003',
//     name: 'Creative Agency Co',
//     contact: 'Mark Thompson',
//     email: 'mark@creative.com',
//     phone: '+1 234 567 8903',
//     totalOrders: 12,
//     totalSpent: '$21,800',
//     status: 'Inactive',
//     rating: 3,
//     joinDate: '2023-09-10',
//     gender: 'Male',
//     requirement: 'Consulting',
//     location: 'Bengaluru',
//     comment: 'Budget constraints',
//     gstUpdate: false
//   },
//   {
//     id: 'C-004',
//     name: 'Global Enterprises',
//     contact: 'Rachel Green',
//     email: 'rachel@global.com',
//     phone: '+1 234 567 8904',
//     totalOrders: 31,
//     totalSpent: '$67,900',
//     status: 'Active',
//     rating: 5,
//     joinDate: '2023-05-03',
//     gender: 'Female',
//     requirement: 'Enterprise Suite',
//     location: 'Mumbai',
//     comment: 'Premium tier account',
//     gstUpdate: true
//   },
//   {
//     id: 'C-005',
//     name: 'Digital Solutions Ltd',
//     contact: 'Tom Wilson',
//     email: 'tom@digital.com',
//     phone: '+1 234 567 8905',
//     totalOrders: 9,
//     totalSpent: '$15,400',
//     status: 'Active',
//     rating: 4,
//     joinDate: '2023-11-18',
//     gender: 'Male',
//     requirement: 'SaaS Platform',
//     location: 'Chennai',
//     comment: 'Requires integration support',
//     gstUpdate: false
//   }
// ];

// // Helper for status badge styling
// const getStatusStyles = (status) => {
//   return status === 'Active'
//     ? { backgroundColor: '#dcfce7', color: '#15803d', fontWeight: '500', padding: '2px 10px', borderRadius: '9999px', fontSize: '12px' }
//     : { backgroundColor: '#f5f5f5', color: '#525252', fontWeight: '500', padding: '2px 10px', borderRadius: '9999px', fontSize: '12px' };
// };

// const CustomerManagement = () => {
//   const [customers, setCustomers] = useState(initialCustomersData);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedViewCustomer, setSelectedViewCustomer] = useState(null);
//   const [activeFormCustomer, setActiveFormCustomer] = useState(null);
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

//   // Screen width observer to accurately toggle responsive inline templates 
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth < 768;

//   const filteredCustomers = customers.filter(c =>
//     c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     c.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     c.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     c.location.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.max(1, Math.ceil(filteredCustomers.length / ITEMS_PER_PAGE));
//   const safePage = Math.min(currentPage, totalPages);
//   const pagedCustomers = filteredCustomers.slice((safePage - 1) * ITEMS_PER_PAGE, safePage * ITEMS_PER_PAGE);

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     setCurrentPage(1);
//   };

//   const handleOpenEmptyForm = () => {
//     setActiveFormCustomer({
//       id: '',
//       name: '',
//       contact: '',
//       email: '',
//       phone: '',
//       totalOrders: 0,
//       totalSpent: '$0',
//       status: 'Active',
//       rating: 5,
//       joinDate: new Date().toISOString().split('T')[0],
//       gender: 'Male',
//       requirement: '',
//       location: '',
//       comment: '',
//       gstUpdate: false
//     });
//   };

//   const handleInputChange = (e) => {
//     if (!activeFormCustomer) return;
//     const { name, value, type } = e.target;

//     setActiveFormCustomer(prev => {
//       if (!prev) return null;
//       if (type === 'checkbox') {
//         const checked = e.target.checked;
//         return { ...prev, [name]: checked };
//       }
//       return { ...prev, [name]: value };
//     });
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     if (!activeFormCustomer) return;

//     if (activeFormCustomer.id) {
//       setCustomers(prev => prev.map(c => c.id === activeFormCustomer.id ? activeFormCustomer : c));
//     } else {
//       const nextIdNumber = customers.length + 1;
//       const generatedId = `C-${String(nextIdNumber).padStart(3, '0')}`;
//       const newCustomerRecord = { ...activeFormCustomer, id: generatedId };
//       setCustomers(prev => [newCustomerRecord, ...prev]);
//     }
//     setActiveFormCustomer(null);
//   };

//   // Reusable inline style definitions
//   const labelStyle = {
//     display: 'block',
//     fontSize: '12px',
//     fontWeight: 'bold',
//     color: '#737373',
//     textTransform: 'uppercase',
//     letterSpacing: '0.05em',
//     marginBottom: '4px'
//   };

//   const inputStyle = {
//     width: '100%',
//     boxSizing: 'border-box',
//     padding: '8px 12px',
//     fontSize: '14px',
//     backgroundColor: '#fafafa',
//     border: '1px solid #e5e5e5',
//     borderRadius: '8px',
//     outline: 'none',
//     color: '#171717',
//     transition: 'all 0.2s'
//   };

//   const cardStyle = {
//     backgroundColor: '#ffffff',
//     border: '1px solid #e5e5e5',
//     borderRadius: '12px',
//     padding: '16px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//   };

//   const buttonSecondaryStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '8px',
//     padding: '8px 16px',
//     backgroundColor: '#f5f5f5',
//     color: '#171717',
//     border: '1px solid #e5e5e5',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   };

//   const buttonPrimaryStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '8px',
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: '#ffffff',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//   };

//   return (
//     <div style={{ padding: isMobile ? '16px' : '32px', maxWidth: '1280px', margin: '0 auto', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column', gap: '20px' }}>

//       {/* Upper Navigation Header */}
//       <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'between', justifyItems: 'space-between', width: '100%', gap: '16px' }}>
//         <div style={{ flexGrow: 1 }}>
//           <h1 style={{ color: '#171717', fontSize: '24px', fontWeight: '700', margin: '0 0 4px 0', trackingTight: '-0.025em' }}>CRM Dashboard</h1>
//           <p style={{ color: '#666666', fontSize: '14px', margin: 0 }}>Manage, edit, and track customer lifecycles</p>
//         </div>
//         <div style={{ display: 'flex', gap: '12px', width: isMobile ? '100%' : 'auto' }}>
//           <button style={{ ...buttonSecondaryStyle, flex: isMobile ? 1 : 'initial' }}>
//             <Download size={16} />
//             <span>Export</span>
//           </button>
//           <button onClick={handleOpenEmptyForm} style={{ ...buttonPrimaryStyle, flex: isMobile ? 1 : 'initial' }}>
//             <Plus size={16} />
//             <span>Add Customer</span>
//           </button>
//         </div>
//       </div>

//       {/* Numerical Analysis Blocks */}
//       <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))', gap: '16px' }}>
//         <div style={cardStyle}>
//           <p style={{ color: '#666666', fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Total Customers</p>
//           <h3 style={{ color: '#171717', fontSize: '24px', fontWeight: '700', margin: 0 }}>{customers.length}</h3>
//           <p style={{ color: '#16a34a', fontSize: '12px', margin: '4px 0 0 0', fontWeight: '500' }}>+12.5% this month</p>
//         </div>
//         <div style={cardStyle}>
//           <p style={{ color: '#666666', fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Active Profiles</p>
//           <h3 style={{ color: '#171717', fontSize: '24px', fontWeight: '700', margin: 0 }}>{customers.filter(c => c.status === 'Active').length}</h3>
//           <p style={{ color: '#16a34a', fontSize: '12px', margin: '4px 0 0 0', fontWeight: '500' }}>Live Accounts</p>
//         </div>
//         <div style={cardStyle}>
//           <p style={{ color: '#666666', fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Avg. Order Value</p>
//           <h3 style={{ color: '#171717', fontSize: '24px', fontWeight: '700', margin: 0 }}>$2,145</h3>
//           <p style={{ color: '#16a34a', fontSize: '12px', margin: '4px 0 0 0', fontWeight: '500' }}>+8.2% vs last month</p>
//         </div>
//         <div style={cardStyle}>
//           <p style={{ color: '#666666', fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Lifetime Value</p>
//           <h3 style={{ color: '#171717', fontSize: '24px', fontWeight: '700', margin: 0 }}>$3.2M</h3>
//           <p style={{ color: '#16a34a', fontSize: '12px', margin: '4px 0 0 0', fontWeight: '500' }}>+15.3% this quarter</p>
//         </div>
//       </div>

//       {/* Query Search Filter Section */}
//       <div style={cardStyle}>
//         <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '16px' }}>
//           <div style={{ flexGrow: 1, position: 'relative', display: 'flex', alignItems: 'center' }}>
//             <Search size={16} style={{ position: 'absolute', left: '12px', color: '#666666', pointerEvents: 'none' }} />
//             <input
//               type="text"
//               placeholder="Search by company name, contact, location..."
//               value={searchTerm}
//               onChange={(e) => handleSearch(e.target.value)}
//               style={{ ...inputStyle, paddingLeft: '36px', backgroundColor: '#f5f5f5', border: 'none' }}
//             />
//           </div>
//           <button style={buttonSecondaryStyle}>
//             <Filter size={16} />
//             Filter
//           </button>
//         </div>
//       </div>

//       {/* Core Customer Records Section */}
//       <div style={{ ...cardStyle, padding: isMobile ? '16px' : '24px' }}>

//         {/* DESKTOP UI VIEW TABLE */}
//         {!isMobile && (
//           <div style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
//               <thead>
//                 <tr style={{ borderBottom: '1px solid #e5e5e5', color: '#666666', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>ID</th>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>Company</th>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>Contact</th>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>Location</th>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>Requirement</th>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>Gst Verified</th>
//                   <th style={{ textAlign: 'left', padding: '12px 16px', fontWeight: '600' }}>Status</th>
//                   <th style={{ textAlign: 'right', padding: '12px 16px', fontWeight: '600' }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody style={{ color: '#171717' }}>
//                 {pagedCustomers.map((customer) => (
//                   <tr key={customer.id} style={{ borderBottom: '1px solid #f5f5f5', transition: 'background-color 0.2s' }}>
//                     <td style={{ padding: '14px 16px', fontFamily: 'monospace', fontSize: '12px', color: '#666666' }}>{customer.id}</td>
//                     <td style={{ padding: '14px 16px', fontWeight: '500' }}>{customer.name}</td>
//                     <td style={{ padding: '14px 16px' }}>
//                       <div>
//                         <div style={{ fontWeight: '500' }}>{customer.contact}</div>
//                         <div style={{ color: '#666666', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
//                           <Mail size={12} /> {customer.email}
//                         </div>
//                       </div>
//                     </td>
//                     <td style={{ padding: '14px 16px' }}>{customer.location}</td>
//                     <td style={{ padding: '14px 16px' }}>
//                       <span style={{ padding: '2px 8px', backgroundColor: '#f5f5f5', color: '#171717', fontSize: '12px', borderRadius: '4px', border: '1px solid #e5e5e5' }}>
//                         {customer.requirement || 'None Specified'}
//                       </span>
//                     </td>
//                     <td style={{ padding: '14px 16px' }}>
//                       {customer.gstUpdate ? (
//                         <span style={{ color: '#16a34a', fontWeight: '600', fontSize: '12px' }}>✔ Verified</span>
//                       ) : (
//                         <span style={{ color: '#ef4444', fontSize: '12px' }}>✖ Unverified</span>
//                       )}
//                     </td>
//                     <td style={{ padding: '14px 16px' }}>
//                       <span style={getStatusStyles(customer.status)}>
//                         {customer.status}
//                       </span>
//                     </td>
//                     <td style={{ padding: '14px 16px', textAlign: 'right' }}>
//                       <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '4px' }}>
//                         <button 
//                           onClick={() => setSelectedViewCustomer(customer)}
//                           style={{ padding: '6px', background: 'none', border: 'none', cursor: 'pointer', color: '#666666', borderRadius: '6px' }}
//                           title="View Full Profile"
//                         >
//                           <Eye size={16} />
//                         </button>
//                         <button 
//                           onClick={() => setActiveFormCustomer({ ...customer })}
//                           style={{ padding: '6px', background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', borderRadius: '6px' }}
//                           title="Edit Customer Details"
//                         >
//                           <Edit size={16} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* MOBILE UI NO-SCROLL LAYOUT */}
//         {isMobile && (
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//             {pagedCustomers.map((customer) => (
//               <div key={customer.id} style={{ border: '1px solid #e5e5e5', borderRadius: '12px', padding: '16px', backgroundColor: 'rgba(245,245,245,0.4)', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #e5e5e5', paddingBottom: '8px' }}>
//                   <div>
//                     <h4 style={{ fontWeight: '700', color: '#171717', margin: 0 }}>{customer.name}</h4>
//                     <span style={{ fontSize: '12px', color: '#666666', fontFamily: 'monospace' }}>{customer.id} | Since {customer.joinDate}</span>
//                   </div>
//                   <span style={getStatusStyles(customer.status)}>
//                     {customer.status}
//                   </span>
//                 </div>

//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '12px', fontSize: '12px' }}>
//                   <div>
//                     <span style={{ color: '#666666', display: 'block', fontWeight: '500' }}>Contact Person</span>
//                     <span style={{ color: '#171717', fontWeight: '500' }}>{customer.contact}</span>
//                   </div>
//                   <div>
//                     <span style={{ color: '#666666', display: 'block', fontWeight: '500' }}>Location</span>
//                     <span style={{ color: '#171717', fontWeight: '500' }}>{customer.location || 'N/A'}</span>
//                   </div>
//                   <div>
//                     <span style={{ color: '#666666', display: 'block', fontWeight: '500' }}>Requirement</span>
//                     <span style={{ color: '#171717', fontWeight: '500' }}>{customer.requirement || 'N/A'}</span>
//                   </div>
//                   <div>
//                     <span style={{ color: '#666666', display: 'block', fontWeight: '500' }}>GST Verified</span>
//                     <span style={{ color: customer.gstUpdate ? "#16a34a" : "#ef4444", fontWeight: '700' }}>
//                       {customer.gstUpdate ? "✔ Yes" : "✖ No"}
//                     </span>
//                   </div>
//                 </div>

//                 <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', paddingTop: '8px', borderTop: '1px solid #e5e5e5' }}>
//                   <button 
//                     onClick={() => setSelectedViewCustomer(customer)}
//                     style={{ ...buttonSecondaryStyle, padding: '6px 12px', fontSize: '12px' }}
//                   >
//                     <Eye size={14} /> View
//                   </button>
//                   <button 
//                     onClick={() => setActiveFormCustomer({ ...customer })}
//                     style={{ ...buttonPrimaryStyle, padding: '6px 12px', fontSize: '12px' }}
//                   >
//                     <Edit size={14} /> Edit Data
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {filteredCustomers.length === 0 && (
//           <p style={{ textAlign: 'center', color: '#666666', padding: '32px 0', fontSize: '14px', margin: 0 }}>No matching records found.</p>
//         )}

//         {/* Pagination Footer */}
//         {filteredCustomers.length > 0 && (
//           <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', justifyContent: 'space-between', gap: '12px', paddingTop: '16px', marginTop: '8px', borderTop: '1px solid #e5e5e5' }}>
//             <p style={{ fontSize: '12px', color: '#666666', margin: 0 }}>
//               Showing <span style={{ fontWeight: '600', color: '#171717' }}>{(safePage - 1) * ITEMS_PER_PAGE + 1}</span>–<span style={{ fontWeight: '600', color: '#171717' }}>{Math.min(safePage * ITEMS_PER_PAGE, filteredCustomers.length)}</span> of <span style={{ fontWeight: '600', color: '#171717' }}>{filteredCustomers.length}</span> records
//             </p>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//               <button
//                 onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
//                 disabled={safePage === 1}
//                 style={{ display: 'flex', alignItems: 'center', padding: '6px', borderRadius: '8px', border: '1px solid #e5e5e5', backgroundColor: '#ffffff', color: '#666666', cursor: safePage === 1 ? 'not-allowed' : 'pointer', opacity: safePage === 1 ? 0.4 : 1 }}
//               >
//                 <ChevronLeft size={16} />
//               </button>

//               {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
//                 <button
//                   key={page}
//                   onClick={() => setCurrentPage(page)}
//                   style={{
//                     width: '32px',
//                     height: '32px',
//                     borderRadius: '8px',
//                     fontSize: '12px',
//                     fontWeight: '500',
//                     border: page === safePage ? 'none' : '1px solid #e5e5e5',
//                     backgroundColor: page === safePage ? '#2563eb' : '#ffffff',
//                     color: page === safePage ? '#ffffff' : '#666666',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   {page}
//                 </button>
//               ))}

//               <button
//                 onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
//                 disabled={safePage === totalPages}
//                 style={{ display: 'flex', alignItems: 'center', padding: '6px', borderRadius: '8px', border: '1px solid #e5e5e5', backgroundColor: '#ffffff', color: '#666666', cursor: safePage === totalPages ? 'not-allowed' : 'pointer', opacity: safePage === totalPages ? 0.4 : 1 }}
//               >
//                 <ChevronRight size={16} />
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* DYNAMIC FORM OVERLAY (ADD & EDIT DUAL-CAPABILITY) */}
//       {activeFormCustomer && (
//         <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 50, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', backdropFilter: 'blur(4px)' }}>
//           <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e5e5', borderRadius: '12px', width: '100%', maxWidth: '512px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', overflow: 'hidden', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', borderBottom: '1px solid #e5e5e5', backgroundColor: 'rgba(245,245,245,0.2)' }}>
//               <div>
//                 <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#171717', margin: 0 }}>
//                   {activeFormCustomer.id ? 'Edit Customer Profile' : 'Add New CRM Record'}
//                 </h2>
//                 <p style={{ fontSize: '12px', color: '#666666', margin: 0 }}>
//                   {activeFormCustomer.id ? 'Modify workspace profile database metrics' : 'Initialize a fresh customer entry data sheet'}
//                 </p>
//               </div>
//               <button 
//                 onClick={() => setActiveFormCustomer(null)}
//                 style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#666666' }}
//               >
//                 <X size={20} />
//               </button>
//             </div>

//             <form onSubmit={handleFormSubmit} style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px', overflowY: 'auto', flexGrow: 1 }}>
//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
//                 <div>
//                   <label style={labelStyle}>Company Name</label>
//                   <input type="text" name="name" value={activeFormCustomer.name} onChange={handleInputChange} required style={inputStyle} placeholder="e.g. Acme Corp" />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Primary Contact</label>
//                   <input type="text" name="contact" value={activeFormCustomer.contact} onChange={handleInputChange} required style={inputStyle} placeholder="Full Name" />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Email ID</label>
//                   <input type="email" name="email" value={activeFormCustomer.email} onChange={handleInputChange} required style={inputStyle} placeholder="name@domain.com" />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Mobile Number</label>
//                   <input type="text" name="phone" value={activeFormCustomer.phone} onChange={handleInputChange} required style={inputStyle} placeholder="+1..." />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Gender</label>
//                   <select name="gender" value={activeFormCustomer.gender} onChange={handleInputChange} style={inputStyle}>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                     <option value="Other">Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Location</label>
//                   <input type="text" name="location" value={activeFormCustomer.location} onChange={handleInputChange} required style={inputStyle} placeholder="City name" />
//                 </div>
//                 <div>
//                   <label style={labelStyle}>Account Status</label>
//                   <select name="status" value={activeFormCustomer.status} onChange={handleInputChange} style={inputStyle}>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>
//               </div>

//               <div>
//                 <label style={labelStyle}>Requirement Specification</label>
//                 <input type="text" name="requirement" value={activeFormCustomer.requirement} onChange={handleInputChange} placeholder="What is their product interest?" style={inputStyle} />
//               </div>

//               <div>
//                 <label style={labelStyle}>Internal Comments / Remarks</label>
//                 <textarea rows={3} name="comment" value={activeFormCustomer.comment} onChange={handleInputChange} placeholder="Write interaction log notes..." style={{ ...inputStyle, resize: 'none' }} />
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px', backgroundColor: 'rgba(245,245,245,0.4)', borderRadius: '12px', border: '1px solid #e5e5e5' }}>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
//                   <label htmlFor="gstUpdate" style={{ fontSize: '14px', fontWeight: '600', color: '#171717', cursor: 'pointer' }}>GstVerified Toggle</label>
//                   <p style={{ fontSize: '12px', color: '#666666', margin: 0 }}>Mark validation credentials status</p>
//                 </div>
//                 <input 
//                   type="checkbox" 
//                   id="gstUpdate" 
//                   name="gstUpdate" 
//                   checked={activeFormCustomer.gstUpdate} 
//                   onChange={handleInputChange}
//                   style={{ width: '16px', height: '16px', cursor: 'pointer' }} 
//                 />
//               </div>

//               <div style={{ display: 'flex', gap: '12px', paddingTop: '12px', borderTop: '1px solid #e5e5e5', marginTop: '16px' }}>
//                 <button 
//                   type="button" 
//                   onClick={() => setActiveFormCustomer(null)} 
//                   style={{ ...buttonSecondaryStyle, flex: 1, padding: '10px' }}
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   type="submit" 
//                   style={{ ...buttonPrimaryStyle, flex: 1, padding: '10px' }}
//                 >
//                   {activeFormCustomer.id ? 'Save Changes' : 'Create Record'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* COMPACT VIEW PROFILE DETAILS OVERLAY */}
//       {selectedViewCustomer && (
//         <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 50, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', backdropFilter: 'blur(4px)' }}>
//           <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e5e5', borderRadius: '12px', width: '100%', maxWidth: '448px', padding: '24px', position: 'relative', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
//             <button 
//               onClick={() => setSelectedViewCustomer(null)}
//               style={{ position: 'absolute', right: '16px', top: '16px', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#666666' }}
//             >
//               <X size={20} />
//             </button>
//             <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#171717', margin: '0 0 16px 0' }}>Customer Details Overview</h3>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', paddingBottom: '6px' }}>
//                 <span style={{ color: '#666666' }}>Company Name:</span>
//                 <span style={{ color: '#171717', fontWeight: '700' }}>{selectedViewCustomer.name}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', paddingBottom: '6px' }}>
//                 <span style={{ color: '#666666' }}>Contact:</span>
//                 <span style={{ color: '#171717', fontWeight: '500' }}>{selectedViewCustomer.contact} ({selectedViewCustomer.gender})</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', paddingBottom: '6px' }}>
//                 <span style={{ color: '#666666' }}>Email / Mobile:</span>
//                 <span style={{ color: '#171717', fontSize: '12px', textAlign: 'right' }}>{selectedViewCustomer.email}<br/>{selectedViewCustomer.phone}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', paddingBottom: '6px' }}>
//                 <span style={{ color: '#666666' }}>Location:</span>
//                 <span style={{ color: '#171717', fontWeight: '500' }}>{selectedViewCustomer.location || 'N/A'}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', paddingBottom: '6px' }}>
//                 <span style={{ color: '#666666' }}>Requirement Focus:</span>
//                 <span style={{ color: '#2563eb', fontWeight: '500' }}>{selectedViewCustomer.requirement || 'N/A'}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e5e5e5', paddingBottom: '6px' }}>
//                 <span style={{ color: '#666666' }}>GST Status:</span>
//                 <span style={{ color: selectedViewCustomer.gstUpdate ? "#16a34a" : "#ef4444", fontWeight: '700' }}>
//                   {selectedViewCustomer.gstUpdate ? "Verified ✓" : "Unverified ✖"}
//                 </span>
//               </div>
//               <div style={{ backgroundColor: 'rgba(245,245,245,0.4)', padding: '8px', borderRadius: '8px', border: '1px solid #e5e5e5', marginTop: '8px' }}>
//                 <span style={{ color: '#666666', fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px' }}>Remarks & Comments</span>
//                 <p style={{ color: '#171717', fontSize: '12px', style: 'italic', margin: 0 }}>{selectedViewCustomer.comment || "No logs updated yet."}</p>
//               </div>
//             </div>

//             <button 
//               onClick={() => setSelectedViewCustomer(null)}
//               style={{ ...buttonSecondaryStyle, width: '100%', marginTop: '20px', padding: '8px' }}
//             >
//               Dismiss View
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default CustomerManagement;


// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBriefcase, FaVenusMars, FaClipboardList, FaTags, FaTrash, FaEdit, FaDatabase, FaSearch, FaCalendarAlt, FaIdBadge, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

// const CustomerManagement = () => {
//   const [search, setSearch] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
//   const customersPerPage = 10;

//   const [customers, setCustomers] = useState([]);
//   const [editingCustomer, setEditingCustomer] = useState(null);

//   // Track window resizing safely for mobile/desktop layout switching
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     fetchLeads();
//   }, []);

//   const fetchLeads = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       if (!user?.id) {
//         console.warn("User ID not found in sessionStorage");
//         return;
//       }
//       const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
//         params: { user_id: user.id }
//       });
//       // Filter only INTERESTED leads
//       const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
//       setCustomers(interestedLeads);
//     } catch (err) {
//       console.error('Error fetching leads:', err);
//     }
//   };

//   const handleEdit = (customer) => setEditingCustomer({ ...customer });

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this customer?')) return;
//     try {
//       await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/delete/${id}`);
//       const updated = customers.filter(c => c.id !== id);
//       setCustomers(updated);
//       // Adjust page if last item was deleted on last page
//       if ((currentPage - 1) * customersPerPage >= updated.length && currentPage > 1) {
//         setCurrentPage(currentPage - 1);
//       }
//     } catch (error) {
//       console.error('Failed to delete customer:', error);
//       alert('Error deleting customer. Please try again.');
//     }
//   };

//   const handleUpdate = async () => {
//     try {
//       const { id, ...updatedData } = editingCustomer;
//       await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/update/${id}`, updatedData);
//       setCustomers(prev =>
//         prev.map(cust => (cust.id === id ? editingCustomer : cust))
//       );
//       setEditingCustomer(null);
//     } catch (error) {
//       console.error('Failed to update customer:', error);
//       alert('Failed to update customer. Please try again.');
//     }
//   };

//   const handleSearch = (e) => {
//     setSearch(e.target.value);
//     setCurrentPage(1);
//   };

//   const filtered = customers.filter((c) =>
//     c.name?.toLowerCase().includes(search.toLowerCase()) ||
//     c.email?.toLowerCase().includes(search.toLowerCase()) ||
//     c.contact?.toLowerCase().includes(search.toLowerCase()) ||
//     c.location?.toLowerCase().includes(search.toLowerCase())
//   );

//   const indexOfLast = currentPage * customersPerPage;
//   const indexOfFirst = indexOfLast - customersPerPage;
//   const currentCustomers = filtered.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(filtered.length / customersPerPage);

//   const handleCallClick = (contact) => {
//     window.location.href = `tel:${contact}`;
//   };

//   const maskEmail = (email) => {
//     if (!email) return '';
//     const [user, domain] = email.split('@');
//     if (!domain) return email;
//     const visibleUser = user.slice(0, 2);
//     const maskedUser = '*'.repeat(Math.max(0, user.length - 2));
//     return `${visibleUser}${maskedUser}@${domain}`;
//   };

//   // Modern input rendering configuration block
//   const renderInput = (label, name, value, onChange, icon) => (
//     <label style={{ display: 'flex', flexDirection: 'column', fontSize: '13px', fontWeight: '600', gap: '6px', color: '#4A5568' }}>
//       <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>{icon} {label}</span>
//       <input 
//         style={{ 
//           padding: '10px', 
//           fontSize: '13px', 
//           border: '1px solid #CBD5E1', 
//           borderRadius: '6px',
//           outline: 'none',
//           backgroundColor: '#F8FAFC',
//           fontWeight: 'normal'
//         }} 
//         value={value || ''} 
//         onChange={(e) => onChange(e.target.value)} 
//         placeholder={`Enter ${label}`} 
//       />
//     </label>
//   );

//   return (
//     <div style={{ fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif', padding: '24px', backgroundColor: '#F1F5F9', minHeight: '100vh', color: '#1E293B' }}>

//       {/* Header Panel */}
//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', background: '#ffffff', padding: '20px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
//         <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: 0, fontSize: '22px', color: '#0F172A' }}>
//           <FaDatabase style={{ color: '#3B82F6' }} /> CRM Dashboard
//         </h2>
//         <div style={{ background: '#EFF6FF', color: '#1D4ED8', padding: '6px 14px', borderRadius: '20px', fontWeight: '600', fontSize: '13px' }}>
//           Total Customers: {filtered.length}
//         </div>
//       </div>

//       {/* Edit Form Modal/Card */}
//       {editingCustomer && (
//         <div style={{ background: '#ffffff', padding: '24px', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)', marginBottom: '24px', borderLeft: '4px solid #3B82F6' }}>
//           <h3 style={formTitle}><FaClipboardList style={{ color: '#3B82F6' }} /> Edit Customer Records</h3>
//           <div style={formGrid}>
//             {renderInput('Name', 'name', editingCustomer.name, val => setEditingCustomer({ ...editingCustomer, name: val }), <FaUser style={{color: '#64748B'}} />)}
//             {renderInput('Email', 'email', editingCustomer.email, val => setEditingCustomer({ ...editingCustomer, email: val }), <FaEnvelope style={{color: '#64748B'}} />)}
//             {renderInput('Contact', 'contact', editingCustomer.contact, val => setEditingCustomer({ ...editingCustomer, contact: val }), <FaPhone style={{color: '#64748B'}} />)}
//             {renderInput('Gender', 'gender', editingCustomer.gender, val => setEditingCustomer({ ...editingCustomer, gender: val }), <FaVenusMars style={{color: '#64748B'}} />)}
//             {renderInput('Requirement', 'requirement', editingCustomer.requirement, val => setEditingCustomer({ ...editingCustomer, requirement: val }), <FaClipboardList style={{color: '#64748B'}} />)}
//             {renderInput('Location', 'location', editingCustomer.location, val => setEditingCustomer({ ...editingCustomer, location: val }), <FaMapMarkerAlt style={{color: '#64748B'}} />)}
//             {renderInput('Comment', 'Comment', editingCustomer.Comment, val => setEditingCustomer({ ...editingCustomer, Comment: val }), <FaBriefcase style={{color: '#64748B'}} />)}
//             {renderInput('GST Number', 'gst', editingCustomer.gst, val => setEditingCustomer({ ...editingCustomer, gst: val }), <FaIdBadge style={{color: '#64748B'}} />)}
//           </div>
//           <div style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'flex-end' }}>
//             <button style={{ ...buttonStyle, backgroundColor: '#EF4444' }} onClick={() => setEditingCustomer(null)}>Cancel</button>
//             <button style={{ ...buttonStyle, backgroundColor: '#10B981' }} onClick={handleUpdate}>Update Details</button>
//           </div>
//         </div>
//       )}

//       {/* Global Search Strip */}
//       <div style={{ marginBottom: '20px', maxWidth: '400px', position: 'relative' }}>
//         <FaSearch style={{ position: 'absolute', top: '13px', left: '14px', color: '#94A3B8', fontSize: '14px' }} />
//         <input 
//           type="text" 
//           value={search} 
//           onChange={handleSearch} 
//           placeholder="Search by name, email, contact..." 
//           style={{ padding: '11px 16px 11px 40px', width: '100%', fontSize: '14px', border: '1px solid #CBD5E1', borderRadius: '8px', outline: 'none', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', backgroundColor: '#fff' }} 
//         />
//       </div>

//       {/* Main Data Layout */}
//       <div style={{ background: '#ffffff', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>

//         {/* Table View (Desktop Layout) */}
//         <div style={{ overflowX: 'auto', display: windowWidth > 768 ? 'block' : 'none' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
//             <thead>
//               <tr style={{ background: '#F8FAFC', borderBottom: '2px solid #E2E8F0' }}>
//                 <th style={thStyle}>#</th>
//                 <th style={thStyle}><span style={thFlex}><FaUser /> Name</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaEnvelope /> Email ID</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaPhone /> Mobile</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaVenusMars /> Gender</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaClipboardList /> Requirement</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaMapMarkerAlt /> Location</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaBriefcase /> Comment</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaCalendarAlt /> Created</span></th>
//                 <th style={thStyle}><span style={thFlex}><FaTags /> GST</span></th>
//                 <th style={thStyle}>Verified</th>
//                 <th style={{ ...thStyle, textAlign: 'center' }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentCustomers.length > 0 ? currentCustomers.map((cust, idx) => {
//                 const isVerified = (cust.gst || '').trim() !== '';
//                 return (
//                   <tr key={cust.id} style={{ borderBottom: '1px solid #E2E8F0', transition: 'background 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F8FAFC'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
//                     <td style={tdStyle}>{indexOfFirst + idx + 1}</td>
//                     <td style={{ ...tdStyle, fontWeight: '600', color: '#0F172A' }}>{cust.name}</td>
//                     <td style={tdStyle}>{maskEmail(cust.email)}</td>
//                     <td style={tdStyle}>
//                       <span onClick={() => handleCallClick(cust.contact)} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: '#2563EB', cursor: 'pointer', fontWeight: '500' }}>
//                         <FaPhone style={{ fontSize: '11px' }} /> {cust.contact}
//                       </span>
//                     </td>
//                     <td style={tdStyle}>{cust.gender}</td>
//                     <td style={tdStyle}>{cust.requirement}</td>
//                     <td style={tdStyle}>{cust.location}</td>
//                     <td style={tdStyle}>{cust.Comment}</td>
//                     <td style={tdStyle}>{cust.createdDate ? new Date(cust.createdDate).toLocaleDateString() : 'N/A'}</td>
//                     <td style={tdStyle}>{cust.gst || 'N/A'}</td>
//                     <td style={tdStyle}>
//                       {isVerified ? <FaCheckCircle style={{ color: '#10B981', fontSize: '16px' }} /> : <FaTimesCircle style={{ color: '#EF4444', fontSize: '16px' }} />}
//                     </td>
//                     <td style={{ ...tdStyle, textAlign: 'center' }}>
//                       <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
//                         <button style={{ ...actionBtnStyle, color: '#2563EB', backgroundColor: '#EFF6FF' }} onClick={() => handleEdit(cust)} title="Edit"><FaEdit /></button>
//                         <button style={{ ...actionBtnStyle, color: '#DC2626', backgroundColor: '#FEF2F2' }} onClick={() => handleDelete(cust.id)} title="Delete"><FaTrash /></button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               }) : (
//                 <tr>
//                   <td colSpan="12" style={{ textAlign: 'center', padding: '32px', color: '#64748B', fontSize: '14px' }}>No active customers found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Card Stack View (Mobile Layout) */}
//         <div style={{ display: windowWidth <= 768 ? 'block' : 'none', padding: '12px' }}>
//           {currentCustomers.length > 0 ? currentCustomers.map((cust, idx) => {
//             const isVerified = (cust.gst || '').trim() !== '';
//             return (
//               <div key={cust.id} style={{ background: '#fff', padding: '16px', marginBottom: '14px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.04)', border: '1px solid #E2E8F0' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #F1F5F9', paddingBottom: '8px', marginBottom: '10px' }}>
//                   <span style={{ fontWeight: '700', color: '#3B82F6' }}>#{indexOfFirst + idx + 1}</span>
//                   <span>{isVerified ? <span style={{ color: '#10B981', fontWeight: '600', fontSize: '12px' }}>✔ Verified</span> : <span style={{ color: '#EF4444', fontWeight: '600', fontSize: '12px' }}>✖ Unverified</span>}</span>
//                 </div>

//                 <div style={mobileRowStyle}><strong>Name:</strong> <span>{cust.name}</span></div>
//                 <div style={mobileRowStyle}><strong>Email:</strong> <span>{maskEmail(cust.email)}</span></div>
//                 <div style={mobileRowStyle}>
//                   <strong>Mobile:</strong> 
//                   <span onClick={() => handleCallClick(cust.contact)} style={{ color: '#2563EB', cursor: 'pointer', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
//                     <FaPhone /> {cust.contact}
//                   </span>
//                 </div>
//                 <div style={mobileRowStyle}><strong>Gender:</strong> <span>{cust.gender}</span></div>
//                 <div style={mobileRowStyle}><strong>Requirement:</strong> <span>{cust.requirement}</span></div>
//                 <div style={mobileRowStyle}><strong>Location:</strong> <span>{cust.location}</span></div>
//                 <div style={mobileRowStyle}><strong>Comment:</strong> <span>{cust.Comment}</span></div>
//                 <div style={mobileRowStyle}><strong>Created:</strong> <span>{cust.createdDate ? new Date(cust.createdDate).toLocaleDateString() : 'N/A'}</span></div>
//                 <div style={mobileRowStyle}><strong>GST:</strong> <span>{cust.gst || 'N/A'}</span></div>

//                 <div style={{ display: 'flex', gap: '10px', marginTop: '14px', pt: '10px', borderTop: '1px solid #F1F5F9' }}>
//                   <button style={{ ...mobileActionBtn, color: '#2563EB', border: '1px solid #BFDBFE', backgroundColor: '#EFF6FF' }} onClick={() => handleEdit(cust)}><FaEdit /> Edit</button>
//                   <button style={{ ...mobileActionBtn, color: '#DC2626', border: '1px solid #FECACA', backgroundColor: '#FEF2F2' }} onClick={() => handleDelete(cust.id)}><FaTrash /> Delete</button>
//                 </div>
//               </div>
//             );
//           }) : (
//             <div style={{ textAlign: 'center', padding: '24px', color: '#64748B' }}>No active customers found.</div>
//           )}
//         </div>
//       </div>

//       {/* Pagination View Wrapper */}
//       {totalPages > 1 && (
//         <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
//           <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={paginationBtn(currentPage !== 1)}>Previous</button>
//           <span style={{ fontSize: '14px', color: '#4A5568', fontWeight: '500' }}>
//             Page <strong>{currentPage}</strong> of {totalPages}
//           </span>
//           <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} style={paginationBtn(currentPage !== totalPages)}>Next</button>
//         </div>
//       )}
//     </div>
//   );
// };

// // Layout configurations
// const formTitle = { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '18px', marginTop: 0, color: '#0F172A', fontSize: '16px' };
// const formGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '12px' };
// const buttonStyle = { padding: '10px 20px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: 'white', border: 'none', borderRadius: '6px', transition: 'opacity 0.2s' };
// const actionBtnStyle = { fontSize: '14px', padding: '6px', cursor: 'pointer', border: 'none', borderRadius: '6px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' };

// const thStyle = { padding: '14px 12px', color: '#475569', fontWeight: '600', borderBottom: '1px solid #E2E8F0' };
// const thFlex = { display: 'inline-flex', alignItems: 'center', gap: '6px' };
// const tdStyle = { padding: '12px', color: '#334155', verticalAlign: 'middle' };

// const mobileRowStyle = { display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '6px', color: '#334155' };
// const mobileActionBtn = { flex: 1, padding: '8px', fontSize: '13px', fontWeight: '500', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' };

// const paginationBtn = (active) => ({
//   padding: '8px 16px',
//   borderRadius: '6px',
//   border: '1px solid #CBD5E1',
//   cursor: active ? 'pointer' : 'not-allowed',
//   backgroundColor: active ? '#ffffff' : '#E2E8F0',
//   color: active ? '#1E293B' : '#94A3B8',
//   fontSize: '13px',
//   fontWeight: '600',
//   boxShadow: active ? '0 1px 2px rgba(0,0,0,0.05)' : 'none'
// });

// export default CustomerManagement;


















import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Search, Shield, Edit, Trash2, X, UserCheck, Mail, Phone, MapPin, FileText, MessageSquare, FileCheck, CheckCircle2, XCircle, UserPlus } from 'lucide-react';

const CustomerManagement = () => {
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const customersPerPage = 10;
  const [customers, setCustomers] = useState([]);

  const [modalCustomer, setModalCustomer] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));
      if (!user?.id) {
        console.warn("User ID not found in sessionStorage");
        return;
      }
      const response = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management`, {
        params: { user_id: user.id }
      });
      const interestedLeads = response.data.filter(cust => cust.status === "INTERESTED");
      setCustomers(interestedLeads);
    } catch (err) {
      console.error('Error fetching leads:', err);
    }
  };

  const handleOpenAddModal = () => {
    setIsCreating(true);
    setModalCustomer({
      name: '',
      email: '',
      contact: '',
      gender: '',
      requirement: '',
      location: '',
      Comment: '',
      gst: '',
      status: 'INTERESTED'
    });
  };

  const handleEdit = (customer) => {
    setIsCreating(false);
    // Normalize or match gender casing if necessary, or fallback safely
    const existingGender = customer.gender ? customer.gender.trim() : '';
    // Capitalize first letter to match options like 'Male', 'Female', 'Other' if stored lowercase
    const formattedGender = existingGender ? existingGender.charAt(0).toUpperCase() + existingGender.slice(1).toLowerCase() : '';

    setModalCustomer({
      ...customer,
      gender: ['Male', 'Female', 'Other'].includes(formattedGender) ? formattedGender : existingGender
    });
  };

  const handleCloseModal = () => {
    setModalCustomer(null);
    setIsCreating(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;
    try {
      await axios.delete(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/delete/${id}`);
      const updated = customers.filter(c => c.id !== id);
      setCustomers(updated);
      if ((currentPage - 1) * customersPerPage >= updated.length && currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    } catch (error) {
      console.error('Failed to delete customer:', error);
      alert('Error deleting customer. Please try again.');
    }
  };

  const handleSave = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userData"));

      if (isCreating) {
        const payload = {
          ...modalCustomer,
          user_id: user?.id,
          status: "INTERESTED"
        };
        await axios.post(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/create`, payload);
        await fetchLeads();
      } else {
        const { id, ...updatedData } = modalCustomer;
        await axios.put(`https://cloudapi.emedhatechnologies.com/pages/api/api/lesdcustomers/update/${id}`, updatedData);
        setCustomers(prev =>
          prev.map(cust => (cust.id === id ? modalCustomer : cust))
        );
      }
      handleCloseModal();
    } catch (error) {
      console.error('Failed to save customer:', error);
      alert('Failed to save customer details. Please try again.');
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const filtered = customers.filter((c) =>
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase()) ||
    c.contact?.toLowerCase().includes(search.toLowerCase()) ||
    c.location?.toLowerCase().includes(search.toLowerCase())
  );

  const indexOfLast = currentPage * customersPerPage;
  const indexOfFirst = indexOfLast - customersPerPage;
  const currentCustomers = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / customersPerPage);

  const handleCallClick = (contact) => {
    window.location.href = `tel:${contact}`;
  };

  const maskEmail = (email) => {
    if (!email) return '';
    const [user, domain] = email.split('@');
    if (!domain) return email;
    const visibleUser = user.slice(0, 2);
    const maskedUser = '*'.repeat(Math.max(0, user.length - 2));
    return `${visibleUser}${maskedUser}@${domain}`;
  };

  const isMobile = windowWidth < 640;
  const isTablet = windowWidth < 768;

  const colors = { bgMain: '#f9fafb', textMain: '#1f2937', textDark: '#111827', textMuted: '#6b7280', borderLight: '#e5e7eb', indigoPrimary: '#4f46e5', indigoHover: '#4338ca', indigoBg: '#f5f3ff', indigoBorder: '#e0e7ff', white: '#ffffff', mutedBg: '#f3f4f6', greenBg: '#dcfce7', greenText: '#15803d', dangerBg: '#fef2f2', dangerText: '#b91c1c', cardShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)' };
  const containerStyle = { maxWidth: '80rem', marginLeft: 'auto', marginRight: 'auto', backgroundColor: colors.bgMain, color: colors.textMain, fontFamily: 'system-ui, -apple-system, sans-serif', boxSizing: 'border-box', width: '100%', padding: '1rem' };
  const cardStyle = { backgroundColor: colors.white, border: `1px solid ${colors.borderLight}`, borderRadius: '1rem', boxShadow: colors.cardShadow, boxSizing: 'border-box' };
  const labelStyle = { display: 'flex', flexDirection: 'column', fontSize: '0.75rem', fontWeight: '700', color: colors.textMuted, textTransform: 'uppercase', letterSpacing: '0.05em', gap: '0.375rem' };

  const renderInput = (label, value, onChange, icon) => (
    <label style={labelStyle}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
        {React.cloneElement(icon, { style: { width: '0.875rem', height: '0.875rem', color: colors.textMuted } })}
        {label}
      </span>
      <input style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', backgroundColor: '#f9fafb', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', boxSizing: 'border-box', color: colors.textDark, fontWeight: 'normal', fontFamily: 'inherit' }} value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={`Enter ${label}`} />
    </label>
  );

  const renderSelect = (label, value, onChange, icon, options) => {
    // If the database has a value not strictly in the array, add it dynamically so it doesn't break selection
    const currentVal = value || '';
    const augmentedOptions = options.includes(currentVal) || !currentVal ? options : [currentVal, ...options];

    return (
      <label style={labelStyle}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          {React.cloneElement(icon, { style: { width: '0.875rem', height: '0.875rem', color: colors.textMuted } })}
          {label}
        </span>
        <select
          style={{ width: '100%', padding: '0.5rem 0.75rem', fontSize: '0.875rem', backgroundColor: '#f9fafb', border: `1px solid ${colors.borderLight}`, borderRadius: '0.75rem', outline: 'none', boxSizing: 'border-box', color: colors.textDark, fontWeight: 'normal', fontFamily: 'inherit' }}
          value={currentVal}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="" disabled>Select {label}</option>
          {augmentedOptions.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </label>
    );
  };

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', gap: '1rem', borderBottom: `1px solid ${colors.borderLight}`, paddingBottom: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <h1 style={{ fontSize: isMobile ? '1.25rem' : '1.5rem', fontWeight: '700', letterSpacing: '-0.025em', color: colors.textDark, display: 'flex', alignItems: 'center', gap: '0.625rem', margin: 0 }}>
            <div style={{ backgroundColor: colors.indigoBg, borderRadius: '0.75rem', border: `1px solid ${colors.indigoBorder}`, display: 'flex', padding: '0.375rem' }}>
              <UserCheck style={{ width: isMobile ? '1.25rem' : '1.5rem', height: isMobile ? '1.25rem' : '1.5rem', color: colors.indigoPrimary }} />
            </div>
            CRM Dashboard
          </h1>
          <p style={{ fontSize: isMobile ? '0.75rem' : '0.875rem', color: colors.textMuted, marginTop: '0.25rem', margin: 0 }}>Manage, edit, and track customer lifecycles</p>
        </div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: isMobile ? '100%' : 'auto', flexWrap: 'wrap' }}>
          <div style={{ backgroundColor: colors.indigoBg, color: colors.indigoPrimary, padding: '0.5rem 1rem', borderRadius: '9999px', fontWeight: '600', fontSize: '0.875rem', border: `1px solid ${colors.indigoBorder}`, textAlign: 'center', boxSizing: 'border-box' }}>Total Customers: {filtered.length}</div>
          <button
            onClick={handleOpenAddModal}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', backgroundColor: colors.indigoPrimary, color: colors.white, border: 'none', padding: '0.5rem 1rem', borderRadius: '0.75rem', fontWeight: '600', fontSize: '0.875rem', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)', flex: isMobile ? 1 : 'unset', justifyContent: 'center' }}
          >
            <UserPlus style={{ width: '1rem', height: '1rem' }} /> Add New Customer
          </button>
        </div>
      </div>

      <div style={{ ...cardStyle, padding: '1rem', marginBottom: '1.5rem' }}>
        <div style={{ position: 'relative', maxWidth: '28rem', display: 'flex', alignItems: 'center' }}>
          <Search style={{ position: 'absolute', left: '0.75rem', width: '1rem', height: '1rem', color: '#9ca3af' }} />
          <input type="text" value={search} onChange={handleSearch} placeholder="Search by name, email, contact..." style={{ width: '100%', padding: '0.5rem 1rem 0.5rem 2.25rem', backgroundColor: '#f9fafb', border: `1px solid ${colors.borderLight}`, fontSize: '0.875rem', borderRadius: '0.75rem', outline: 'none', boxSizing: 'border-box', color: colors.textDark }} />
        </div>
      </div>

      <div style={cardStyle}>
        {!isTablet && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse', fontSize: '12px' }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${colors.borderLight}`, backgroundColor: 'rgba(249, 250, 251, 0.7)', fontSize: '0.65rem', fontWeight: '700', textTransform: 'uppercase', color: colors.textMuted }}>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>#</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Name</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Email ID</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Mobile</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Gender</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Requirement</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Location</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Comment</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Created</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>GST</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Verified</th>
                  <th style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top' }}>Actions</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: colors.white }}>
                {currentCustomers.length > 0 ? currentCustomers.map((cust, idx) => {
                  const isVerified = (cust.gst || '').trim() !== '';
                  return (
                    <tr key={cust.id} style={{ borderBottom: `1px solid ${colors.borderLight}`, transition: 'background-color 0.2s', }}>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{indexOfFirst + idx + 1}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{cust.name}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{maskEmail(cust.email)}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}> <span onClick={() => handleCallClick(cust.contact)} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: colors.indigoPrimary, cursor: 'pointer', fontWeight: '600' }}><Phone style={{ width: '0.75rem', height: '0.75rem' }} /> {cust.contact}</span></td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{cust.gender}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>
                        <span style={{ padding: '0.125rem 0.5rem', backgroundColor: colors.neutralBg, color: colors.textDark, fontSize: '0.65rem', borderRadius: '0.25rem', border: `1px solid ${colors.borderLight}` }}>
                          {cust.requirement || ''}
                        </span>
                      </td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{cust.location}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{cust.Comment}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{cust.createdDate ? new Date(cust.createdDate).toLocaleDateString() : ''}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>{cust.gst || ''}</td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>
                        {isVerified ? (
                          <CheckCircle2 style={{ color: colors.greenText, width: '1.125rem', height: '1.125rem' }} />
                        ) : (
                          <XCircle style={{ color: colors.dangerText, width: '1.125rem', height: '1.125rem' }} />
                        )}
                      </td>
                      <td style={{ padding: '8px', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', fontSize: '0.62rem' }}>
                        <div style={{ display: 'flex', gap: '0.125rem', justifyContent: 'center' }}>
                          <button onClick={() => handleEdit(cust)} style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.indigoPrimary }} title="Edit">
                            <Edit style={{ width: '1rem', height: '1rem' }} />
                          </button>
                          <button onClick={() => handleDelete(cust.id)} style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: colors.dangerText }} title="Delete">
                            <Trash2 style={{ width: '1rem', height: '1rem' }} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                }) : (
                  <tr>
                    <td colSpan="12" style={{ textAlign: 'center', padding: '2rem', color: colors.textMuted, fontStyle: 'italic' }}>No active customers found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {isTablet && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '1rem' }}>
            {currentCustomers.length > 0 ? currentCustomers.map((cust, idx) => {
              const isVerified = (cust.gst || '').trim() !== '';
              return (
                <div key={cust.id} style={{
                  background: colors.white, padding: '1rem', borderRadius: '0.75rem',
                  display: 'flex', flexDirection: 'column', gap: '0.75rem',
                  border: `1px solid ${colors.borderLight}`, boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${colors.borderLight}`, paddingBottom: '0.5rem' }}>
                    <span style={{ fontWeight: '700', color: colors.indigoPrimary }}>#{indexOfFirst + idx + 1}</span>
                    <span>
                      {isVerified ? (
                        <span style={{ color: colors.greenText, fontWeight: '600', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}><CheckCircle2 style={{ width: '0.875rem', height: '0.875rem' }} /> Verified</span>
                      ) : (
                        <span style={{ color: colors.dangerText, fontWeight: '600', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}><XCircle style={{ width: '0.875rem', height: '0.875rem' }} /> Unverified</span>
                      )}
                    </span>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.75rem' }}>
                    <div><strong style={{ color: colors.textMuted }}>Name:</strong> <span style={{ color: colors.textDark, fontWeight: '500' }}>{cust.name}</span></div>
                    <div><strong style={{ color: colors.textMuted }}>Gender:</strong> <span style={{ color: colors.textDark }}>{cust.gender}</span></div>
                    <div><strong style={{ color: colors.textMuted }}>Email:</strong> <span style={{ color: colors.textDark }}>{maskEmail(cust.email)}</span></div>
                    <div>
                      <strong style={{ color: colors.textMuted }}>Mobile:</strong> {' '}
                      <span onClick={() => handleCallClick(cust.contact)} style={{ color: colors.indigoPrimary, cursor: 'pointer', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '0.125rem' }}>
                        <Phone style={{ width: '0.75rem', height: '0.75rem' }} /> {cust.contact}
                      </span>
                    </div>
                    <div style={{ gridColumn: 'span 2' }}><strong style={{ color: colors.textMuted }}>Requirement:</strong> <span style={{ color: colors.textDark }}>{cust.requirement}</span></div>
                    <div><strong style={{ color: colors.textMuted }}>Location:</strong> <span style={{ color: colors.textDark }}>{cust.location}</span></div>
                    <div><strong style={{ color: colors.textMuted }}>Created:</strong> <span style={{ color: colors.textDark }}>{cust.createdDate ? new Date(cust.createdDate).toLocaleDateString() : 'N/A'}</span></div>
                    <div style={{ gridColumn: 'span 2' }}><strong style={{ color: colors.textMuted }}>Comment:</strong> <span style={{ color: colors.textDark, fontStyle: 'italic' }}>{cust.Comment}</span></div>
                    <div style={{ gridColumn: 'span 2' }}><strong style={{ color: colors.textMuted }}>GST Number:</strong> <span style={{ color: colors.textDark, fontFamily: 'monospace' }}>{cust.gst || 'N/A'}</span></div>
                  </div>

                  <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: `1px solid ${colors.borderLight}` }}>
                    <button onClick={() => handleEdit(cust)} style={{ flex: 1, padding: '0.375rem 0.75rem', fontSize: '0.75rem', fontWeight: '500', borderRadius: '0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', color: colors.indigoPrimary, backgroundColor: colors.indigoBg, border: 'none' }}>
                      <Edit style={{ width: '0.875rem', height: '0.875rem' }} /> Edit
                    </button>
                    <button onClick={() => handleDelete(cust.id)} style={{ flex: 1, padding: '0.375rem 0.75rem', fontSize: '0.75rem', fontWeight: '500', borderRadius: '0.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', color: colors.dangerText, backgroundColor: colors.dangerBg, border: 'none' }}>
                      <Trash2 style={{ width: '0.875rem', height: '0.875rem' }} /> Delete
                    </button>
                  </div>
                </div>
              );
            }) : (
              <div style={{ textAlign: 'center', padding: '1.5rem', color: colors.textMuted, fontStyle: 'italic' }}>No active customers found.</div>
            )}
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.75rem' }}>
          <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', border: `1px solid ${colors.borderLight}`, fontSize: '0.875rem', fontWeight: '500', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', backgroundColor: currentPage === 1 ? '#e5e7eb' : colors.white, color: currentPage === 1 ? '#9ca3af' : colors.textMain, opacity: currentPage === 1 ? 0.6 : 1 }}>Previous</button>
          <span style={{ fontSize: '0.875rem', color: colors.textMuted, fontWeight: '500' }}>Page <strong style={{ color: colors.textDark }}>{currentPage}</strong> of {totalPages}</span>
          <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', border: `1px solid ${colors.borderLight}`, fontSize: '0.875rem', fontWeight: '500', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', backgroundColor: currentPage === totalPages ? '#e5e7eb' : colors.white, color: currentPage === totalPages ? '#9ca3af' : colors.textMain, opacity: currentPage === totalPages ? 0.6 : 1 }}>Next</button>
        </div>
      )}

      {modalCustomer && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999, backgroundColor: 'rgba(17, 24, 39, 0.4)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: isMobile ? 'center' : 'flex-end', overflowY: 'auto' }}>
          <div style={{ backgroundColor: colors.white, width: '100%', maxWidth: '36rem', minHeight: '100vh', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', boxSizing: 'border-box' }}>
            <div style={{ padding: '1.25rem', borderBottom: `1px solid ${colors.borderLight}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f9fafb' }}>
              <div>
                <h3 style={{ fontSize: '1rem', fontWeight: '700', color: colors.textDark, margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FileText style={{ width: '1.25rem', height: '1.25rem', color: colors.indigoPrimary }} />
                  {isCreating ? 'Add New Customer' : 'Edit Customer Records'}
                </h3>
                <p style={{ fontSize: '11px', color: colors.textMuted, marginTop: '0.125rem', margin: 0 }}>
                  {isCreating ? 'Fill out the form below to create a new customer lead.' : 'Modify operational database values to assure metadata synchronization.'}
                </p>
              </div>
              <button type="button" onClick={handleCloseModal} style={{ padding: '0.375rem', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', display: 'flex' }}>
                <X style={{ width: '1.25rem', height: '1.25rem' }} />
              </button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '1.25rem' : '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem', boxSizing: 'border-box' }}>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                {renderInput('Name', modalCustomer.name, val => setModalCustomer({ ...modalCustomer, name: val }), <UserCheck />)}
                {renderInput('Email ID', modalCustomer.email, val => setModalCustomer({ ...modalCustomer, email: val }), <Mail />)}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                {renderInput('Contact Mobile', modalCustomer.contact, val => setModalCustomer({ ...modalCustomer, contact: val }), <Phone />)}
                {renderSelect('Gender Identifier', modalCustomer.gender, val => setModalCustomer({ ...modalCustomer, gender: val }), <Shield />, ['Male', 'Female', 'Other'])}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                {renderInput('Requirement Spec', modalCustomer.requirement, val => setModalCustomer({ ...modalCustomer, requirement: val }), <FileCheck />)}
                {renderInput('Location Zone', modalCustomer.location, val => setModalCustomer({ ...modalCustomer, location: val }), <MapPin />)}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1rem' }}>
                {renderInput('Comment Logs', modalCustomer.Comment, val => setModalCustomer({ ...modalCustomer, Comment: val }), <MessageSquare />)}
                {renderInput('GST Registration Number', modalCustomer.gst, val => setModalCustomer({ ...modalCustomer, gst: val }), <FileText />)}
              </div>
            </div>

            <div style={{ padding: '1rem', borderTop: `1px solid ${colors.borderLight}`, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '0.75rem', backgroundColor: '#f9fafb' }}>
              <button type="button" onClick={handleCloseModal} style={{ padding: '0.5rem 1rem', fontSize: '0.875rem', fontWeight: '500', border: `1px solid ${colors.borderLight}`, backgroundColor: colors.white, borderRadius: '0.75rem', cursor: 'pointer', color: '#374151' }}>Cancel</button>
              <button type="button" onClick={handleSave} style={{ padding: '0.5rem 1.25rem', fontSize: '0.875rem', fontWeight: '500', backgroundColor: colors.indigoPrimary, color: colors.white, border: 'none', borderRadius: '0.75rem', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}>
                {isCreating ? 'Create Customer' : 'Update Details'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerManagement;